/**
 * @group Constants
 * @summary Apple App Store URL for the mobile app download CTA.
 *
 * @example
 * ```typescript
 * import { APPLE_APP_STORE_URL } from '@shared/constants';
 *
 * window.open(APPLE_APP_STORE_URL, '_blank');
 * ```
 */
export const APPLE_APP_STORE_URL = 'https://apps.apple.com/za/app/phila/id6755953225' as const;
